<template>
	<div>
		<router-view />
	</div>
</template>

<script>
	/**
	 * App.vue 是所有页面的根组件，它在整个应用生命周期中只会挂载一次。把逻辑放在这里，进入项目时就会自动全局生效。
	 */
	export default {
		name: 'App',
		mounted() {
			const rawLanguage = navigator.language || navigator.userLanguage; // 1. 获取用户浏览器偏好语言 (例如: "en-US", "zh-CN")
			// 2. 特殊处理：如果支持列表里有精确的 "en-US"，就用原值；  如果没有，则截取前两位 (例如 "en-US" -> "en", "zh-CN" -> "zh") 进行模糊匹配
			let userLanguage = this.$p_languages.includes(rawLanguage) ? rawLanguage : rawLanguage.toLowerCase().substring(
				0, 2);
			const isLanguageSupported = this.$p_languages.includes(userLanguage); // 3. 再次检查截取后的语言（如 "en"）是否在支持列表中
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage; // 4. 设置最终语言：受支持就用它，否则用默认语言
			// 打印一下，方便你在控制台肉眼排查当前到底生效了什么语言
			console.log('【I18n 调试】浏览器原始语言:', rawLanguage, ' | 最终生效语言:', this.$i18n.locale);
		}
	}
</script>

<style>
</style>